export default __webpack_public_path__ + "static/media/intro2.3f4c2d1b.mp3";